import React, { useEffect, lazy } from 'react';
import { trackPixel } from '../utils/pixel';
const tomes = [{
  number: '01',
  label: '0–6m',
  sublabel: 'El Despertar Sensorial',
  desc: 'Sistema nervioso, vínculo, control postural, Tummy Time y estimulación visual y auditiva.',
  image: 'https://cdn.magicpatterns.com/uploads/tkBJcYg3JtVVp5NncMPm7A/ChatGPT_Image_20_abr_2026,_22_31_34.webp'
}, {
  number: '02',
  label: '6–12m',
  sublabel: 'Movimiento y Descubrimiento',
  desc: 'Sedestación, gateo, prensión, causa-efecto y transición a la alimentación.',
  image: 'https://cdn.magicpatterns.com/uploads/ozcyTRxiiKwWeBmPaCovoF/ChatGPT_Image_20_abr_2026,_22_32_00.webp'
}, {
  number: '03',
  label: '12–18m',
  sublabel: 'Primeros Pasos y Palabras',
  desc: 'Marcha, pointing, primeras palabras, juego funcional y autonomía inicial.',
  image: 'https://cdn.magicpatterns.com/uploads/fQddBt3BDQKfbv1pHBdZ3c/ChatGPT_Image_20_abr_2026,_22_33_45.webp'
}, {
  number: '04',
  label: '18–24m',
  sublabel: 'Lenguaje y Juego',
  desc: 'Frases de dos palabras, grafomotricidad, juego simbólico y estructura del "No".',
  image: 'https://cdn.magicpatterns.com/uploads/e4vD2UDW9HeWoSyV3sDZNL/ChatGPT_Image_20_abr_2026,_22_34_13.webp'
}, {
  number: '05',
  label: '24–30m',
  sublabel: 'Pensamiento y Coordinación',
  desc: 'Conceptos básicos, control de impulsos, pre-escritura e identidad propia.',
  image: 'https://cdn.magicpatterns.com/uploads/4kPnYqZuudccfDWg9quYuH/ChatGPT_Image_20_abr_2026,_22_34_48.webp'
}, {
  number: '06',
  label: '30–36m',
  sublabel: 'Integración y Pre-Escolaridad',
  desc: 'Narración corta, marcha compleja, control de esfínteres y preparación escolar.',
  image: 'https://cdn.magicpatterns.com/uploads/tMx7wzfPKhBiMmjA3hiNpL/ChatGPT_Image_20_abr_2026,_22_35_15.webp'
}];
export function ProductShowcase() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    background: 'linear-gradient(180deg, #ffffff 0%, #ffffff 60%, rgb(240,249,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-248">
      <div className="mx-auto max-w-4xl text-center" data-id="element-249">
        {/* Badge */}
        <div className="mb-4 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-cyan-brand border border-cyan-brand/50 bg-cyan-brand/5 rounded-full px-4 py-1.5" data-id="element-250">
          🏆 El sistema más completo de Estimulación Temprana
        </div>

        {/* Title */}
        <h2 className="text-2xl font-black text-gray-900 m-0 mb-2" data-id="element-251">
          MEGAPACK ESTIMULACIÓN TEMPRANA
        </h2>

        {/* Subtitle */}
        <p className="text-sm font-semibold text-gray-700 m-0 mb-1" data-id="element-252">
          6 Tomos + 6 Bonos — Sistema Clínico Completo — Todo resuelto.
        </p>
        <p className="text-sm text-gray-500 m-0 mb-8" data-id="element-253">
          +500 páginas · 144 sesiones modelo · Criterio clínico por etapa ·
          Plantillas de registro · Orientaciones para familias · Radar de
          alertas · Listo para usar hoy.
        </p>

        {/* Tomes Grid */}
        <div className="grid grid-cols-6 gap-3 mb-4" data-id="element-254">
          {tomes.map(tome => <div key={tome.number} className="flex flex-col items-center gap-2" data-id="element-255">
              <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-md border border-gray-100" data-id="element-256">
                <img src={tome.image} alt={tome.sublabel} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-257" />
              </div>
              <div className="text-center" data-id="element-258">
                <span className="block text-[11px] font-black text-gray-900" data-id="element-259">
                  Tomo {tome.number}
                </span>
                <span className="block text-[9px] text-cyan-brand font-bold mt-0.5" data-id="element-260">
                  {tome.label}
                </span>
                <span className="block text-[9px] text-gray-500 leading-tight mt-0.5" style={{
              wordBreak: 'break-word',
              hyphens: 'auto'
            }} data-id="element-261">
                  {tome.sublabel}
                </span>
              </div>
            </div>)}
        </div>

        {/* Badge inferior */}
        <div className="flex justify-center mb-8" data-id="element-262">
          <div className="bg-cyan-brand text-[10px] font-black text-white rounded-full px-4 py-1.5" data-id="element-263">
            6 TOMOS COMPLETOS · 0 A 36 MESES
          </div>
        </div>

        {/* Tomes list */}
        <div className="bg-white border border-cyan-brand/20 rounded-xl overflow-hidden shadow-sm" data-id="element-264">
          <div className="bg-cyan-brand px-5 py-3 text-left" data-id="element-265">
            <h3 className="text-sm font-black text-white m-0" data-id="element-266">
              📚 LOS 6 TOMOS — Sistema de Intervención 0 a 36 meses
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-267">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-268">
                <span className="shrink-0 text-lg font-black text-cyan-brand/30 w-8 text-center" data-id="element-269">
                  {tome.number}
                </span>
                <div className="flex-1 min-w-0 text-left" data-id="element-270">
                  <span className="block text-sm font-black text-gray-900" data-id="element-271">
                    {tome.sublabel}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-272">
                    {tome.desc}
                  </span>
                </div>
                <span className="shrink-0 text-[10px] font-bold text-cyan-brand bg-cyan-brand/5 border border-cyan-brand/20 rounded-full px-2 py-0.5 whitespace-nowrap" data-id="element-273">
                  {tome.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}